/** Plattformen */
export const enum ClientType {
  browser,
  android,
  ios,
  windows,
  osx,
  linux,
}

/** Clientinformationen und Funktionen */
export class Client {
  private _type: ClientType = ClientType.browser;
  private _isMobile: boolean;
  private _version: string;
  private _userAgent: string;
  private _platform: string;
  private _manufacturer: string;
  private _model: string;
  private _isBrowserMobileSafariCache: boolean;
  private _isBrowserSafariCache: boolean;

  constructor(platform: string, manufacturer?: string, model?: string) {
    const me = this;
    // TODO: Wrapper müssen Versionsnummer des Betriebssystems im Useragent übermitteln
    if (typeof device !== "undefined") {
      platform = device.platform;
      manufacturer = device.manufacturer;
      model = device.model;
    }
    if (platform == null) {
      platform = "";
    }
    if (manufacturer == null) {
      manufacturer = "";
    }
    if (model == null) {
      model = "";
    }
    me._setPlatform(platform);
    me._setManufacturer(manufacturer);
    me._setModel(model);
    me._setVersion(""); // leer initialisieren
    me._setUserAgent(""); // leer initialisieren
    // navigator is from angular or cordova
    if (typeof navigator !== "undefined" && navigator) {
      me._setUserAgent(navigator.userAgent);
    }

    switch (platform) {
      case "Android": {
        me._setType(ClientType.android);
        break;
      }
      case "iOS": {
        me._setType(ClientType.ios);
        break;
      }
      case "Windows": {
        me._setType(ClientType.windows);
        break;
      }
      case "Mac OS X": {
        me._setType(ClientType.osx);
        break;
      }
      case "Ubuntu": {
        me._setType(ClientType.linux);
        break;
      }
      default: {
        // ClientType keeps browser
        if (typeof navigator !== "undefined") {
          me._setVersion(navigator.appVersion);
        }
        break;
      }
    }
    me._determineIfClientIsMobile();
  }

  /** Aktuelle Plattform */
  public get type(): ClientType {
    return this._type;
  }
  private _setType(value: ClientType) {
    this._type = value;
  }

  /** Gibt an ob die aktuelle Plattform eine Mobilplattform ist */
  public get isMobile(): boolean {
    return this._isMobile;
  }
  private _setIsMobile(value: boolean) {
    this._isMobile = value;
  }

  /** Aktuelle Plattformversion */
  public get version(): string {
    return this._version;
  }

  private _setVersion(value: string) {
    this._version = value;
  }

  /** UserAgent der Webengine */
  public get userAgent(): string {
    return this._userAgent;
  }
  private _setUserAgent(value: string) {
    this._userAgent = value;
  }

  /** Aktueller Device Platform */
  public get platform(): string {
    return this._platform;
  }
  private _setPlatform(value: string) {
    this._platform = value;
  }

  /** Aktueller Device Monufacturer */
  public get manufacturer(): string {
    return this._manufacturer;
  }
  private _setManufacturer(value: string) {
    this._manufacturer = value;
  }

  /** Aktuelles Device Model */
  public get model(): string {
    return this._model;
  }
  private _setModel(value: string) {
    this._model = value;
  }

  /** is Browser Mobile Safari */
  public get isBrowserMobileSafari(): boolean {
    if (this._isBrowserMobileSafariCache == null) {
      // iPad wird nicht als Mobile Safari erkannt
      // userAgent ist "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/16.2 Safari/605.1.15"
      this._isBrowserMobileSafariCache = /(iPhone|iPad).*Mobile.*Safari/.test(
        navigator.userAgent
      );
    }
    return this._isBrowserMobileSafariCache;
  }

  /** is Browser Safari
   * !MARK
   * On iPad, the user agent is recognized as Desktop Safari.
   * Because  "Request desktop website" is default Safari setting
   */
  public get isBrowserSafari(): boolean {
    if (this._isBrowserSafariCache == null) {
      this._isBrowserSafariCache = /(Macintosh).*Version.*Safari/.test(
        navigator.userAgent
      );
    }
    return this._isBrowserSafariCache;
  }

  private _determineIfClientIsMobile() {
    this._setIsMobile(
      this._type === ClientType.android || this._type === ClientType.ios
    );
  }
}
